import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  makeCategoryIsLoading,
  makeCategorySelector,
} from '../../../redux/selectors/categorySelector';
import { makeCatsIsFetching } from '../../../redux/selectors/catsSelector';
import { CategoriesPosition } from '../../../types/Categories';
import CategoriesList from './CategoriesList';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    categories: makeCategorySelector(CategoriesPosition.Home),
    isLoading: makeCategoryIsLoading([CategoriesPosition.Home]),
    isCatFetching: makeCatsIsFetching(),
  });

  return state => selector(state);
};

export default connect(mapStateToProps)(CategoriesList);
